import { notifyError, notifySuccess } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const rescheduleAuction = (id, rescheduleObj, setAuctionDetails, navigate) => async (dispatch) => {
  dispatch({ type: "RESCHEDULE_AUCTION_FETCHING" });
  try {
    const { data } = await auction.post(`/auction/create/industry/reschadule-auction/${id}`, rescheduleObj);
    dispatch({ type: "RESCHEDULE_AUCTION_SUCCESS", payload: data });
    notifySuccess("Auction Rescheduled Successfully");
    setAuctionDetails({
      EMDSchedule: { lastDate: "", lastTime: "" },
      inspectionSchedule: {
        endDate: "",
        inspectionLocation: "",
        startingTime: "",
        endingTime: "",
      },
      auctionSchedule: {
        startDate: "",
        startingTime: "",
        endingTime: "",
      },
      auctionType: "forwardAuction",
      auctionCoordinators: [],
      contractValidity: "",
      bidValidity: "",
      offers: []
    });
    navigate(`/`);
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "CANNOT_RESCHEDULE_AUCTION" });
  }
}